// extracted by mini-css-extract-plugin
export default {"wrapper":"AddMember_wrapper__H97m6","header":"AddMember_header__1cd7a"};